/* eslint-disable no-unused-vars */
// @ts-nocheck
/* eslint-disable react/style-prop-object */
import React, { useState, useEffect, useRef } from 'react';
import { animated, useSpring, config } from 'react-spring';
import ReactMapboxGl, { Marker, Popup } from 'react-mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import useSWR from 'swr';
import { pageView, customEvent } from '../../../Utilities/GoogleAnalytics';
import Select from 'react-select';
import { Link } from 'react-router-dom';

const fetchProvinces = 'https://stamped-cms.herokuapp.com/provinces';
const fetchColleges = 'https://stamped-cms.herokuapp.com/colleges';
const fetchCities = 'https://stamped-cms.herokuapp.com/cities';

const StampedLogo = 'https://res.cloudinary.com/stamped/image/upload/v1608735103/General%20Assets/Logo_bqapy8.png';

/**
 * Fetching Environment Variables
 */
const accessToken = process.env.REACT_APP_MAPBOXACCESSTOKEN;

const fetcher = (...args) => fetch(...args).then((res) => res.json());

// shift it to env
const Map = ReactMapboxGl({
  accessToken,
});

export default function CollegeFinder() {
  const [zoom, setZoom] = useState(5);
  const [mapCenterLong, changeMapCenterLong] = useState(-79.3517047);
  const [mapCenterLat, changeMapCenterLat] = useState(43.7960639);
  const [mapCenter, changeMapCenter] = useState([mapCenterLong, mapCenterLat]);
  const mapRef = useRef(null);
  const [showPopups, changeShowPopups] = useState(false);
  const [showInfoBox, changeShowInfoBox] = useState(false);

  /**
   * Filters
   */
  const [showUNI, setShowUNI] = useState(true);
  const [showColleges, setShowColleges] = useState(true);

  const [selectedCollege, changeSelectedCollege] = useState({
    name: 'Search by College Name',
  });
  const [selectedProvince, changeSelectedProvince] = useState('Search By Province');
  const [selectedCity, changeSelectedCity] = useState('Search By City');
  const { data: provinceList } = useSWR(fetchProvinces, fetcher);
  const { data: collegeList } = useSWR(fetchColleges, fetcher);
  const { data: cityList } = useSWR(fetchCities, fetcher);

  // Experimenting with Zoom Changes
  useEffect(() => {
    console.log('Zoom level', mapRef.current.props.zoom[0]);
  });

  //  updates all the points on the map
  useEffect(() => {
    changeMapCenter([mapCenterLong, mapCenterLat]);
  }, [mapCenterLat, mapCenterLong, provinceList]);

  //On load, let us punch some pageview
  useEffect(() => {
    pageView(window.location.pathname);
  }, []);

  function updateProvince(name) {
    customEvent('Selected Province', name);
    let province = provinceList && provinceList.find((o) => o.name === name);
    changeMapCenterLong(province.long);
    changeMapCenterLat(province.lat);
    changeSelectedProvince(name);
    changeSelectedCity('Search By City');
    changeShowPopups(false);
    setZoom(8);
  }

  function updateCity(name) {
    customEvent('Selected City', name);
    let city = cityList && cityList.find((o) => o.name === name);
    changeMapCenterLong(city.long);
    changeMapCenterLat(city.lat);
    changeSelectedCity(name);
    changeSelectedProvince('Search By Province');
    changeShowPopups(false);
    setZoom(10);
  }

  function updateCollege(name) {
    customEvent('Selected College', name);
    let college = collegeList && collegeList.find((o) => o.name === name);
    changeMapCenterLong(college.long);
    changeMapCenterLat(college.lat);
    changeSelectedCollege(college);
    changeSelectedCity('Search By City');
    changeSelectedProvince('Search By Province');
    changeShowPopups(true);
    changeShowInfoBox(true);
    setZoom(14);
  }

  /**
   * This displays the information for selected college
   */

  const Infobox = () => {
    const customOrderAnimation = useSpring({
      config: config.gentle,
      from: { transform: 'translateY(50px)', opacity: 0.5 },
      to: { transform: 'translateY(0px)', opacity: 1 },
    });

    return (
      <animated.div
        style={customOrderAnimation}
        className={`fixed z-50 pt-4 pb-4 pl-6 pr-6 lg:mt-4 lg:mr-4 mt-16 bg-white rounded-md shadow-lg w-full bottom-0 lg:bottom-auto lg:top-0 lg:right-0 lg:w-1/4`}
      >
        <button
          onClick={() => {
            changeShowInfoBox(false);
          }}
          id="closebutton"
          className="absolute right-0 mr-6 text-2xl text-gray-700 outline-none focus:outline-none"
        >
          ×
        </button>
        <div className="w-1/4 mt-4 mb-4 border-2 border-gray-200 rounded-full ">
          <img className="rounded-full" src={selectedCollege.image ? selectedCollege.image : StampedLogo} alt="Logo" />
        </div>
        <div
          className={`flex-1 pt-1 pb-1 mb-2 mt-2 w-1/3 text-center ${
            selectedCollege.type === 'University' ? 'bg-green-500' : 'bg-orange-500'
          } rounded-full opacity-75`}
        >
          <p className="w-auto text-xs text-white"> {selectedCollege.type} </p>
        </div>
        <h1 className="text-black cursor-pointer"> {selectedCollege.name} </h1>
        <p className="text-xs text-gray-600">{selectedCollege.address}</p>
        <hr className="mt-2 mb-2 text-gray-400" />
        <p className="mb-2 text-xs tracking-wide text-gray-500 uppercase"> About </p>
        <p className="text-sm text-left"> {selectedCollege.description} </p>
        <a href="http://wikipedia.org">
          <p className="my-1 text-xs text-gray-400">© Source: Wikipedia</p>
        </a>
        <hr className="mt-2 mb-2 text-gray-400" />
        <p className="mb-2 text-xs tracking-wide text-gray-500 uppercase"> DLI No. {selectedCollege.dli} </p>
        <hr className="mt-2 mb-2 text-gray-400" />
        <ul className="flex items-center space-x-2 text-xs text-gray-800 cursor-pointer">
          <a target="_blank" rel="noopener noreferrer" href={selectedCollege.coursesURL}>
            <li className="font-semibold hover:text-red-600"> List of courses </li>
          </a>
          <a target="_blank" rel="noopener noreferrer" href={selectedCollege.officialWebsite}>
            <li className="font-semibold hover:text-red-600"> Official Website </li>
          </a>
          <a target="_blank" rel="noopener noreferrer" href={selectedCollege.streetView}>
            <li className="font-semibold hover:text-red-600"> Google Street View </li>
          </a>
        </ul>
      </animated.div>
    );
  };

  /**
   * A call to action element for the screen
   */
  const FollowCTA = () => {
    return (
      <div className="bottom-0 z-10 hidden w-full cursor-pointer lg:block lg:absolute font-brand">
        <div className="flex justify-start text-xs">
          <Link to="/home">
            <div className="flex items-center justify-center">
              <div className="px-2 py-1 font-semibold text-gray-900 bg-white">You don’t need an agent</div>
              <div className="px-2 py-1 -ml-1 font-bold text-white rounded-r-md bg-brandcolor">See why</div>
            </div>
          </Link>
        </div>
      </div>
    );
  };

  /**
   * A call to action element for the screen for Mobile
   */
  const MobileFollowCTA = () => {
    return (
      <div className="fixed z-50 w-full h-auto">
        <div className="px-4 py-1 bg-brandcolor">
          <p className="text-xs font-bold text-center text-white capitalize">
            You don't need an agent –{' '}
            <Link to="/">
              {' '}
              <span className="transition duration-100 border-b-2"> See Why </span> {' '}
            </Link>
          </p>
        </div>
      </div>
    );
  };

  /**
   * A header element that displays the name, logo and other credits
   */
  const Credits = () => (
    <div id={'Credits'} className="flex items-center justify-center lg:block">
      <a href="https://stamped.wiki">
        <div className="mt-3 mb-3 text-center lg:w-full">
          <img src={StampedLogo} alt="Stamped Logo" className="w-12 ml-6 lg:p-0 lg:m-auto lg:w-1/5" />
        </div>
      </a>
      <div className="flex items-center w-full lg:bottom-0 lg:left-0 lg:right-0">
        <h1 className="pl-6 text-xs text-gray-200 lg:text-black lg:pl-0 lg:pt-0 lg:text-center lg:pb-3 lg:m-auto lg:w-1/2">
          Stamped {new Date().getFullYear()} - Canada <br className="lg:hidden" /> University & College Finder.
        </h1>
      </div>
    </div>
  );

  /**
   * A wrapper element that hides anything on mobile
   * @param {*} props - sends in the component inside it
   */
  const DesktopOnly = (props) => <div className="hidden xl:block lg:block">{props.children}</div>;
  /**
   * A weapper element that shows components it wraps, only in mobile
   * @param {Passes the components as props} props
   */
  const MobileOnly = (props) => <div className="block lg:hidden xl:hidden">{props.children}</div>;

  const Filters = () => (
    <div className="flex items-center justify-center w-full space-x-4">
      <button
        className={`px-4 py-2 my-4 text-xs rounded-md outline-none focus:outline-none ${showUNI ? 'bg-white' : 'bg-darkAlt'}`}
        onClick={() => setShowUNI(!showUNI)}
      >
        {' '}
        {showUNI ? 'Hide Universities' : 'Show Universities'}
      </button>
      <button
        className={`px-4 py-2 my-4 text-xs rounded-md outline-none focus:outline-none ${showColleges ? 'bg-white' : 'bg-darkAlt'}`}
        onClick={() => setShowColleges(!showColleges)}
      >
        {' '}
        {showColleges ? 'Hide Colleges' : 'Show Colleges'}
      </button>
    </div>
  );

  /**
   * The panel that allows user to select college, universities etc
   */
  const ActionPanel = () => (
    <div
      id="sidepanel"
      className={`w-full absolute z-20 lg:m-2 rounded-md shadow-lg bg-mapBlack top-0 lg:top-auto lg:left-0 lg:w-1/5 lg:bg-altBack ${
        showInfoBox ? 'opacity-0' : 'opacity-1'
      } lg:opacity-100 `}
    >
      <Credits />
      <Filters />
      <div id={'selectors'} className="mt-1 mb-1 text-xs lg:flex-wrap md:text-md lg:text-md lg:block">
        <Select
          className={` w-full lg:w-full outline-none focus:outline-none`}
          isDisabled={provinceList ? false : true}
          onChange={(e) => updateProvince(e.value)}
          placeholder={provinceList ? selectedProvince : 'Loading Provinces & Territories'}
          label="Select Province"
          options={
            provinceList
              ? provinceList.sort(function (a, b) {
                  return a.name.localeCompare(b.name);
                })
              : ''
          }
        />
        <Select
          className={` w-full lg:w-full outline-none focus:outline-none`}
          isDisabled={cityList ? false : true}
          onChange={(e) => updateCity(e.value)}
          label="Select City"
          placeholder={cityList ? selectedCity : 'Loading Cities'}
          options={
            cityList
              ? cityList
                  .sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                  })
                  .map((cityListItem) => ({ label: cityListItem.name, value: cityListItem.name }))
              : ''
          }
        />
        <Select
          className={` w-full lg:w-full outline-none focus:outline-none`}
          isDisabled={collegeList ? false : true}
          onChange={(e) => updateCollege(e.value)}
          label="Search College"
          placeholder={collegeList ? selectedCollege.name : 'Loading Colleges'}
          options={
            collegeList
              ? collegeList
                  .sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                  })
                  .map((collegeListItem) => ({ label: collegeListItem.name, value: collegeListItem.name }))
              : ''
          }
        />
      </div>
    </div>
  );

  /**
   * Function that maps mobile input bar
   */
  function mobileSelection(e) {
    console.log('Mobile Selection', e);

    // checks if it is a college
    let college = collegeList && collegeList.find((o) => o.name === e);
    if (college) {
      updateCollege(college.name);
      return;
    }
    // checks if it is a city
    let city = cityList && cityList.find((o) => o.name === e);
    if (city) {
      updateCity(city.name);
      return;
    }

    // checks if it is a province
    let province = provinceList && provinceList.find((o) => o.name === e);
    if (province) {
      updateProvince(province.name);
      return;
    }
  }

  const MobileActionBar = () => (
    <div className="fixed bottom-0 z-10 w-full h-16 px-6 py-3 transition-all duration-200 bg-altBack focus-within:h-48">
      <div className="flex items-center space-x-2 text-sm justify-items-start">
        <img className="w-8 h-8 rounded-full" src={selectedCollege.image ? selectedCollege.image : StampedLogo} alt="Logo" />
        <Select
          className={` w-full lg:w-full outline-none focus:outline-none`}
          isDisabled={collegeList ? false : true}
          openMenuOnClick={false}
          onChange={(e) => mobileSelection(e.value)}
          label="Search College"
          placeholder={collegeList ? 'Search by College, Province or City' : 'Loading Options'}
          options={
            collegeList
              ? cityList
                ? provinceList
                  ? provinceList
                      .concat(
                        collegeList
                          .sort(function (a, b) {
                            return a.name.localeCompare(b.name);
                          })
                          .map((collegeListItem) => ({ label: collegeListItem.name, value: collegeListItem.name }))
                      )
                      .concat(
                        cityList
                          .sort(function (a, b) {
                            return a.name.localeCompare(b.name);
                          })
                          .map((cityListItem) => ({ label: cityListItem.name, value: cityListItem.name }))
                      )
                  : ''
                : ''
              : ''
          }
        />
      </div>
    </div>
  );

  return (
    <div className="flex w-full h-screen overflow-hidden bg-mapBlack noselect font-brand">
      <MobileOnly>
        <MobileActionBar />
        <MobileFollowCTA />
      </MobileOnly>
      <DesktopOnly>
        <FollowCTA />
        <ActionPanel />
      </DesktopOnly>
      {showInfoBox && <Infobox />}
      <Map
        style={'mapbox://styles/stamped/ckhfeleog0f6b19lefa997hqi'}
        // @ts-ignore
        center={mapCenter}
        ref={mapRef}
        onZoomEnd={(e) => {
          console.log('Zoom End', e);
          /** TODO: This auto adjusts the marker to exact space */
          setZoom(e.transform.tileZoom);
          if (e.transform.tileZoom < 10) {
            changeShowPopups(false);
          }
        }}
        zoom={[zoom]}
        className="outline-none focus:outline-none"
        containerStyle={{
          height: '100%',
          width: '100vw',
        }}
      >
        <div id="marker-container">
          {collegeList &&
            collegeList
              .filter(function (el) {
                return (el.type === 'University' && showUNI) || (el.type === 'College' && showColleges);
              })
              .map((college) => {
                return (
                  <>
                    <Marker
                      className="cursor-pointer"
                      coordinates={[college.long, college.lat]}
                      onClick={() => {
                        changeMapCenter([college.long, college.lat]);
                        changeShowInfoBox(true);
                        changeSelectedCollege(college);
                        customEvent('Selected College', college.name);
                        changeShowPopups(true);
                        setZoom(13);
                      }}
                    >
                      <img alt="Stamped" width={30 + 'px'} src={StampedLogo} />
                    </Marker>
                    {showPopups && (
                      <Popup
                        style={{ width: '200px' }}
                        coordinates={[college.long, college.lat]}
                        offset={{
                          'bottom-left': [12, -38],
                          bottom: [0, -30],
                          'bottom-right': [-12, -38],
                        }}
                      >
                        <p className="p-2 font-semibold text-md font-brand">
                          <span aria-label="Pointer" role="img">
                            📍
                          </span>
                          &nbsp; {college.name}
                        </p>
                        <div
                          className={`w-1/2 ml-1 text-center ${
                            college.type === 'University' ? 'bg-green-500' : 'bg-orange-500'
                          } rounded-full opacity-75`}
                        >
                          <p className="w-auto text-xs text-white"> {college.type} </p>
                        </div>
                      </Popup>
                    )}
                  </>
                );
              })}
        </div>
      </Map>
      ;
    </div>
  );
}
